/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 *
 * @author <a href="mailto:mskinner@pacificbiosciences.com">Mitch Skinner</a>
 * @author <a href="mailto:ssanfilippo@pacificbiosciences.com">Sal Sanfilippo</a>
 */

export function value(propertyName) {
    return object => object[propertyName]
}

export function valueToDate(propertyName) {
    return object => new Date(object[propertyName])
}

export function valueToUppercase(propertyName) {
    return object => object[propertyName].toUpperCase()
}

export function valueToLowercase(propertyName) {
    return object => object[propertyName].toLowerCase()
}

export function reverse(sortFn) {
    return (object1, object2) => sortFn(object2, object1)
}

export function asc(valueFn: Function) {
    return (object1, object2) => {
        const value1 = valueFn(object1)
        const value2 = valueFn(object2)

        if (value1 < value2) {
            return -1
        } else if (value1 > value2) {
            return 1
        } else {
            return 0
        }
    }
}

export function desc(valueFn) {
    return reverse(asc(valueFn))
}

export function multisort(...propFns: Function[]) {
    return function(a, b) {
        for (let fn of propFns) {
            let result = fn(a, b)
            if (result === 0) {
                continue
            }
            return result
        }
        return 0
    }
}
